<template>
	<div id="other">
		other
	</div>
</template>

<script >
	export default {
		data() {
			return {

			}
		}
	}
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/top/other/other.vue